import { CancelTokenSource } from 'axios';
import { DateTime } from 'luxon';

import { Location } from '@rygen/rygen-ui/model';

import {
  ApiParcelPickupAvailabilityDetails,
  LocationSearchCriteria,
  ParcelSchedulingResponse,
  SHIPMENT_COLUMNS_SORT_FIELDS,
  ShipmentSearchCriteria,
  ShipmentSearchResult,
  UnscheduledParcelShipmentsResposne,
} from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'shipment/parcel';

export class ShipmentParcelController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async unscheduledParcelSearch(
    criteria: ShipmentSearchCriteria,
    cancelToken?: CancelTokenSource,
  ): Promise<ShipmentSearchResult> {
    criteria.referenceSort =
      criteria.sortField !== undefined &&
      !SHIPMENT_COLUMNS_SORT_FIELDS.includes(criteria.sortField);

    const response = await this.http.post<ShipmentSearchResult>(
      'search',
      criteria,
      { cancelToken: cancelToken?.token },
    );
    return new ShipmentSearchResult(response.data);
  }

  async getApiParcelPickupAvailabilityDetails(
    pickupDateTime: DateTime,
    pickupEnd: DateTime | undefined,
    shipmentIds: number[],
  ): Promise<ApiParcelPickupAvailabilityDetails> {
    const response = await this.http.post<ApiParcelPickupAvailabilityDetails>(
      'pickup/availability',
      {
        pickupDateTime: pickupDateTime,
        pickupEnd: pickupEnd,
        shipmentIds: shipmentIds,
      },
    );
    return new ApiParcelPickupAvailabilityDetails(response.data);
  }

  async scheduleParcelPickup(
    pickupDateTime: DateTime,
    pickupEnd: DateTime,
    shipmentIds: number[],
  ): Promise<ParcelSchedulingResponse> {
    const response = await this.http.post<ParcelSchedulingResponse>(
      'pickup/schedule',
      {
        pickupDateTime: pickupDateTime,
        pickupEnd: pickupEnd,
        shipmentIds: shipmentIds,
      },
    );
    return new ParcelSchedulingResponse(response.data);
  }

  async getPossibleParcelPickupLocations(
    query: LocationSearchCriteria,
    cancelToken?: CancelTokenSource,
  ): Promise<Location[]> {
    const response = await this.http.post<Location[]>(
      'pickup/locations',
      query,
      { cancelToken: cancelToken?.token },
    );
    return response.data.map((val) => new Location(val));
  }

  async doesUnscheduledParcelShipmentExist(): Promise<UnscheduledParcelShipmentsResposne> {
    const response =
      await this.http.get<UnscheduledParcelShipmentsResposne>(
        'pickup/unscheduled',
      );
    return new UnscheduledParcelShipmentsResposne(response.data);
  }
}
